<template>
<v-card :class="['result', item.close_out ? 'inactive' : 'active' ]" max-width="450" :ripple="false" @mouseover="hover=true" @mouseleave="hover=false" height="100%">
    <v-img class="white--text align-end" height="200px" :src="item.image?fullImage(item.image):room">
        <div class="alert-image" v-if="!item.image">
            <v-icon class="pa-1" color="red">warning</v-icon>
            <div class="pa-1">
                Nu aveti imagini adaugate pentru acesta camera.
            </div>
        </div>
        <v-icon class="pa-1 icon-editv2" size="32" color="#5A8DEE" v-show="hover" @click="emitClick()">edit</v-icon>
        <v-card-title class="title-card pa-2">
            <span>
                <span>{{item.name}}</span>
                <span class="overline white--text font-weight-medium">({{item.id}})</span>
            </span>
        </v-card-title>
    </v-img>

    <v-card-text class="text--primary">
        <div class="">
            <div class="regular">
                {{ $t('room-type-standards.' + item.standard + '.name') }}
            </div>
            <div class="detail">
                {{ $t('room-type-standards.' + item.standard + '.description') }}
            </div>
        </div>
        <div class="regular">
            Planuri tarifare asociate
        </div>
        <v-row class="" aling="center">
            <template v-if="!item.rate_plans.length">
                <span class="faded orange--text px-3">
                    Nu aveti nici un plan tarifar asociat cu aceasta camera
                </span>
            </template>
            <template v-else-if="item.rate_plans.length<3">
                <v-chip class="cursor-pointer ma-1" v-for="(rate_plan, index) in item.rate_plans" :key="index" small @click="editRatePlan(rate_plan.id)">
                    {{ rate_plan.name }}
                    <span class="faded">({{ rate_plan.id }})</span>
                </v-chip>
            </template>
            <template v-else>
                <v-chip class="cursor-pointer ma-1" small @click="editRatePlan(item.rate_plans[0].id)">
                    {{ item.rate_plans[0].name }}
                    <span class="faded">({{ item.rate_plans[0].id }})</span>
                </v-chip>
                <v-chip class="cursor-pointer ma-1" small @click="editRatePlan(item.rate_plans[1].id)">
                    {{ item.rate_plans[1].name }}
                    <span class="faded">({{ item.rate_plans[1].id }})</span>
                </v-chip>
                <span class="faded" style="align-self: center">+ alte {{item.rate_plans.length-2}} planuri</span>
            </template>
        </v-row>
    </v-card-text>
</v-card>
</template>

<script>
import Room from '../../../assets/room.jpeg';
export default {
    name: `room-types-card`,

    props: {
        item: Object
    },

    data() {
        return {
            hover: false,
            room: Room
        };
    },

    methods: {
        editRatePlan(rate_plan_id) {
            let slug = this.$route.params.hotel_slug;
            this.$router.push({
                path: '/' + slug + '/rate-plans/' + rate_plan_id
            });
        },

        fullImage(url) {
            return url.replace('-small.', "-large.")
        },

        emitClick() {
            this.$emit('edit');
        },
    },
}
</script>
<style lang="stylus">
.icon-editv2
    background-color:  rgba(50, 50, 50, 0.8)
    border-radius: 50%
    position: absolute
    top: 5px
    right: 5px
.title-card
    background-color: rgba(0, 0, 0, 0.2)
    &.v-card__title
        line-height: 1.5rem
        word-break: break-word
.alert-image
    background-color: rgba(255, 166, 77, 0.7)
    position: absolute
    display: flex
    flex-direction: row
    top: 0px
    left: 0px
    padding-right: 14px
    padding-left: 5px

</style>
